<template>
  <li class="menu-item">
    <a href="#" :class="classList" @click.prevent="handleClick"><t-icon :name="iconName"/></a>
    <slot></slot>
  </li>
</template>

<script>
export default {
  // Declares 'click' as a component event (KAT-943 Phase 2b fix): without this, Vue 3's
  // automatic attribute-fallthrough treats an undeclared `@click` listener passed by the parent
  // as a *native* DOM listener as well as a component-emit listener, causing `clickMenuItem` to
  // fire twice — once correctly with `this.target`, once with the raw native PointerEvent,
  // clobbering `mainMenuTab`. (Vue 2's `.native` modifier is gone in Vue 3; this is its
  // replacement mechanism.)
  emits: ['click'],
  data () {
    return {
      localActive: false
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      this.$emit('click', this.target)
    }
  },
  computed: {
    classList () {
      let classes = ''
      if (this.localActive) {
        classes += ' active'
      }

      return classes
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    }
  },
  watch: {
    active (newVal) {
      this.localActive = newVal
    }
  }
}
</script>

<style>

</style>
